import componentSizes from "../constants/componentSizes";

/**
 * @deprecated please use "@streeteasy/design-system/constants/componentSizes" instead
 */
export default {
  SM: componentSizes.SM,
  MD: componentSizes.MD,
  LG: componentSizes.LG
};
